import { Component } from '@angular/core'

@Component({
    selector: 'sf-cta-mobile-app-vertical',
    imports: [],
    templateUrl: './cta-mobile-app-vertical.component.html',
    styleUrl: './cta-mobile-app-vertical.component.scss'
})
export class CtaMobileAppVerticalComponent {}
